var _path, _path2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeproLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6L8 12v10c0 9.4 6.8 18.2 16 20.4C33.2 40.2 40 31.4 40 22V12L24 6z",
    fill: "#1e3a5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23l4.5 4.5 9-9",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 30,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#1e3a5f",
    letterSpacing: -0.5
  }, "Safe")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 97,
    y: 30,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 20,
    fontWeight: 300,
    fill: "#2563eb",
    letterSpacing: -0.5
  }, "Digi")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeproLogo);
export default __webpack_public_path__ + "static/media/safepro-logo.f6d25219eec12de3f25f1ab4ef7c0b75.svg";
export { ForwardRef as ReactComponent };